import * as $ from "jquery";

export default class Promotions {

	constructor(el: HTMLElement) {
		
		$('.promotions__item').on('click', function(e) {
			e.preventDefault();
			const key = $(this).attr('data-tab');

			$('.promotions__item:not([data-tab="'+key+'"])').attr('data-status', '');
			$('.promotions__item[data-tab="'+key+'"]').attr('data-status', 'active');

			$('.promotions__tab:not([data-tab="'+key+'"])').attr('data-status', '');
			$('.promotions__tab[data-tab="'+key+'"]').attr('data-status', 'active');

			const top = $('.promotions__tabs').offset().top - 160;
			$('html, body').stop().animate({
				scrollTop: top,
			}, 600);
		});
	}
}